"use strict"

import { getCookie } from "../utils/cookie-handler";

export function init() {
    const selector = '.js-user-status';
    const inner = '.global-header__button-text'
    const elements = document.querySelectorAll(selector);

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {

        let accountName = getCookie('bo_first_name');

        if (accountName) {
            element.querySelector(inner).innerText = 'Account';
            element.setAttribute('href', element.dataset.accountlink)
        } else {
            element.querySelector(inner).innerText = 'Log In';
            element.setAttribute('href', element.dataset.loginlink)
        }
    });
}

export default { init }
